import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrepStateReleased = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.5 7.5V15.5M8.5 7.5L15.5 4.5M8.5 7.5L1.5 4.5M8.5 15.5L1.5 12.5V4.5M8.5 15.5L15.5 12.5V4.5M15.5 4.5L8.5 1.5L1.5 4.5M12.1667 5.86822L5.28821 2.89677",
		stroke: "currentColor"
	})
});
export default SvgPrepStateReleased;
